import _ from 'lodash';
import appOptions from './appOptions';
import config from '../config';

let storage = {
    dataStorage: {}, // storage fallback for when session storage is not supported

    /**
     * Used to detect if session storage is available or not.
     * https://gist.github.com/paulirish/5558557
     * @return {Boolean} true/false if session storage is suppported
     */
    isSessionStorageSupported() {
        try {
            sessionStorage.setItem('test', 'test');
            sessionStorage.removeItem('test');
            return true;
        } catch (e) {
            return false;
        }
    },

    /**
     * uuid for the storage session for this particular flow
     */
    uuid() {
        return config.params.searchPath;
    },

    /**
     * this returns the global session object for this particular flow based on the uuid
     */
    getSessionObject() {
        let item = sessionStorage.getItem(this.uuid());

        try {
            item = JSON.parse(item);
        } catch (e) {
            if (
                ['dev', 'development', 'test', 'stage'].indexOf(
                    appOptions.get('environment')
                ) !== -1
            ) {
                console.log('unable to parse session object');
            }
        }
        // if sessionObject has not been defined, return a new object
        if (_.isNull(item)) {
            return {};
        }
        return item;
    },

    /**
     * get grabs the session object and returns the value for a particular key
     * @param  {string} key property key in which to retreive
     * @return {[type]}     value of the property
     */
    get(key) {
        let sessionObject;

        if (this.isSessionStorageSupported()) {
            sessionObject = this.getSessionObject();
            return sessionObject[key];
        }
        return this.dataStorage[key];
    },

    /**
     * set places the key and value into the session object
     * @param {string} key   property key to store
     * @param {[type]} value property value to store
     */
    set(key, value) {
        let sessionObject;

        if (this.isSessionStorageSupported()) {
            sessionObject = this.getSessionObject();
            sessionObject[key] = value;
            sessionStorage.setItem(this.uuid(), JSON.stringify(sessionObject));
        } else {
            this.dataStorage[key] = value;
        }
    },

    /**
     * setObject sets an entire object for you with an array of key/value pairs
     * @param {string} objectName       the name of the root object you want to set
     * @param {array}  objectDataArray  array of objects with key/value pairs for storing in objectName
     */
    setObject(objectName, objectDataArray) {
        let storageData = this.get(objectName) || {};

        // iterate over each object in the array
        _.each(objectDataArray, (object) => {
            // for each object iterate through the key/value and store them
            _.each(object, (value, key) => {
                storageData[key] = value;
            });
        });

        this.set(objectName, storageData);
    },

    /**
     * clear this particular session
     */
    clear() {
        if (this.isSessionStorageSupported()) {
            sessionStorage.clear(this.uuid());
        } else {
            this.dataStorage = {};
        }
    },
};

export default storage;
